import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { registerServiceWorkerAutoReload } from "@shared-ui/utils/registerServiceWorkerAutoReload";
import { router } from "./router";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

registerServiceWorkerAutoReload();
